import React from 'react';
import { connect } from 'react-redux';

import { splitChargeCard } from '../utils';
import * as routes from 'app/routes';
import { getPurchaseHistory, getHistoryPagination } from 'reducers';
import Box from 'common/Box';
import Link from 'common/Link';
import Pagination from 'common/Pagination';
import CardIcon from 'billing/CardIcon';
import { LONG_DATE_FORMAT } from 'app_constants';
import { formatDate } from 'helpers/formatters';
import styles from './index.module.css';

export const CardDetails = ({purchase}) => {
  const [cardType, lastFour] = splitChargeCard(purchase.charge_card);

  return (
    <div className={styles.CardIcon}>
      <CardIcon cardType={cardType} color="dark" /> { lastFour }
    </div>
  );
};

export const routePurchaseByStatus = (purchase) => {
  return purchase.status === 'overdue' ? routes.unpaidPurchase(purchase.id) : routes.purchase(purchase.id);
};

export const filterZeroCreditsPurchase = purchase => Boolean(purchase.cost) && !(purchase.cost.total === '0.00');

export const PurchaseHistory = ({ history, ...pagination }) => (
  <div className={styles.PurchaseHistory}>
    {
      history
        .filter(filterZeroCreditsPurchase)
        .map(purchase => (
          <Link to={routePurchaseByStatus(purchase)} key={purchase.id}>
            <Box className={styles.HistoryContainer}>
              <div>{formatDate(purchase.purchase_date, LONG_DATE_FORMAT)}</div>
              <div>#{purchase.id}</div>
              <div className={styles.cardStatus}>
                { purchase.status === 'overdue' ? ('Past Due') : <CardDetails purchase={purchase} /> }
              </div>
              <div className={styles.price}>${purchase.cost.total}</div>
            </Box>
          </Link>
        ))
    }
    { history.length === 0 ? (
      <Box>No Purchases Yet</Box>
    ) : null }
    <Pagination {...pagination} route={routes.purchaseHistory}/>
  </div>
);

const mapStateToProps = (state) => {
  const page = (state.routing && state.routing.query && state.routing.query.page) || 1;
  const { next, previous } = getHistoryPagination(state, page);
  return {
    history: getPurchaseHistory(state, page),
    next,
    previous
  };
}

export default connect(
  mapStateToProps
)(PurchaseHistory);
